





















import { Vue, Component, Prop } from 'vue-property-decorator'
import { DateCallLog } from '@/types/call'
import dayjs from 'dayjs'

@Component({
  components: {
    CallHistoryLog: () => import('@/components/call/CallHistoryLog.vue')
  }
})
export default class CallHistoryDay extends Vue {
  @Prop() dateLog!: DateCallLog

  get dateStr() {
    return dayjs(this.dateLog.date).format('M月D日')
  }
}
